import { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import type { IMatchDetails } from "./types/matchDetails.d";

export function useOpenPlayerProfile() {
  const navigate = useNavigate();
  return useCallback((playerId: string | undefined | null) => {
    const id = playerId?.trim();
    if (!id) return;
    navigate(`/tournaments/player-profile?playerId=${encodeURIComponent(id)}`);
  }, [navigate]);
}

/** Player id for PoTM / squad-style objects (API may send `playerId` or `id`). */
export function playerIdFromMatchPerson(
  person: IMatchDetails["playerOfTheMatch"],
): string | undefined {
  if (!person || typeof person === "string") return undefined;
  const o = person as { playerId?: string; id?: string };
  const raw = o.playerId ?? o.id;
  const id = raw?.trim();
  return id || undefined;
}
